import React, { useState, useEffect } from 'react';
import MultiSelect from  'multiselect-react-dropdown';
import  'react-multiple-select-dropdown-lite/dist/index.css';
import "./selectoption.scss"
import { eventActions } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";
import { colors } from '@material-ui/core';

const SelectWithOption = () => {
  const dispatch = useDispatch();
  const ProductActiveAssignList = useSelector((state) => state.productactiveassignlist.productactiveassignlist);
  const productselectid = useSelector((state) => state.productselectid.productselectid);
  const [value, setvalue] = useState([])


  const onSelectOptions = (selectedList, selectedItem) => {
    setvalue(selectedItem)
    var data = selectedList.map(a => a.cat);
    dispatch(eventActions.productSelectId(data));
  }

  useEffect(() => {
    dispatch(eventActions.ProductActiveAssignList());
}, []);

  // const  options  = [
  //   { label:  'Option 1', value:  'option_1'  },
  //   { label:  'Option 2', value:  'option_2'  },
  //   { label:  'Option 3', value:  'option_3'  },
  //   { label:  'Option 4', value:  'option_4'  },
  // ]

  const option = ProductActiveAssignList && ProductActiveAssignList.sort((a, b) => a.productGroupName.localeCompare(b.productGroupName)) && ProductActiveAssignList.map((item) =>{
    return {
      key: item.productGroupName,
      cat: item.productGroupId
    }
  })
  

  return(
    <div className="select_option">
      <MultiSelect
        // open={true}
        onSelect={onSelectOptions}
        options={option}
        displayValue={"key"}
        avoidHighlightFirstOption={true}
        showArrow={true}
        style={{
          chips: {
            background: 'red',
            // color:'black'
          },
          multiselectContainer: {
            // color: 'red'
            // background: 'lightgrey',
          },
          searchBox: {
            // border: 'none',
            // 'border-bottom': '1px solid blue',
            // 'border-radius': '0px'
          },
          option: { // To change css for dropdown options
            // color: "grey",
            },
        }}
      />
    </div>
)}
export  default SelectWithOption;